import React, {useEffect, useState} from 'react';
import {Button, Form, Input, Modal, Row, Col, message} from 'antd';
import {CommandDto, TimeOffset} from '../../../api';
import {EditOutlined, PauseCircleOutlined} from "@ant-design/icons";
import DescriptionFormItem from "../../form/DescriptionFormItem";

const layout = {
    labelCol: {span: 8},
    wrapperCol: {span: 16},
};

const tailLayout = {
    wrapperCol: {offset: 8, span: 16},
};

const PauseCommandModal = ({onCommandCardData, initialData}: { onCommandCardData: Function; initialData?: CommandDto }) => {
    const [form] = Form.useForm();
    const [isModalVisible, setIsModalVisible] = useState(false); // State für die Modal-Sichtbarkeit

    useEffect(() => {
        // Wenn initialData vorhanden ist, fülle das Formular mit den initialen Daten
        if (initialData) {
            form.setFieldsValue({
                days: initialData.timeOffset?.days,
                hours: initialData.timeOffset?.hours,
                minutes: initialData.timeOffset?.minutes,
                seconds: initialData.timeOffset?.seconds,
                description: initialData.description
            });
        }
    }, [initialData, form]);

    const onFinish = (values) => {
        let days = values.days;
        let hours = values.hours;
        let minutes = values.minutes;
        let seconds = values.seconds;

        if(!days && !hours && !minutes && !seconds){
            message.error("Bitte mindestens einen Wert angeben!");
            return;
        }

        days = days ? days : 0;
        hours = hours ? hours : 0;
        minutes = minutes ? minutes : 0;
        seconds = seconds ? seconds : 0;


        let timeOffset: TimeOffset = {days: days, hours: hours, minutes: minutes, seconds: seconds}
        let command: CommandDto = {timeOffset: timeOffset, commandType: 'PAUSE', description: values.description};
        onCommandCardData(command);
        setIsModalVisible(false); // Modal schließen
    };

    const onReset = () => {
        form.resetFields();
    };

    // Funktion zum Öffnen des Modals
    const showModal = () => {
        setIsModalVisible(true);
    };

    // Funktion zum Schließen des Modals
    const handleCancel = () => {
        setIsModalVisible(false);
    };

    return (
        <>
            {initialData == null &&
                <div style={{display: 'flex', alignItems: 'stretch', justifyContent: 'stretch'}}>
                  <Button
                      type="primary"
                      onClick={showModal}
                      style={{width: '100%', height: '100%'}}
                  >
                    <PauseCircleOutlined/> Pausieren
                  </Button>
                </div>}
            {initialData != null &&
                <Button
                    type="primary"
                    style={{float: 'right'}}
                    onClick={showModal}
                >
                  <EditOutlined/>
                </Button>
            }
            <Modal
                title="Pausieren"
                open={isModalVisible}
                onCancel={handleCancel}
                footer={null}
            >
                <Form
                    {...layout}
                    form={form}
                    name="control-hooks"
                    onFinish={onFinish}
                    style={{maxWidth: 600}}
                >
                    <Form.Item name="days" label="Tage">
                        <Input/>
                    </Form.Item>
                    <Form.Item name="hours" label="Stunden">
                        <Input/>
                    </Form.Item>
                    <Form.Item name="minutes" label="Minuten">
                        <Input/>
                    </Form.Item>
                    <Form.Item name="seconds" label="Sekunden">
                        <Input/>
                    </Form.Item>
                    <DescriptionFormItem />
                    <Form.Item {...tailLayout}>
                        <Row justify="center">
                            <Col style={{marginRight: 2.5}}>
                                <Button type="primary" htmlType="submit">
                                    {initialData ? "Speichern" : "Hinzufügen"}
                                </Button>
                            </Col>
                            <Col style={{marginRight: 2.5}}>
                                <Button htmlType="button" onClick={onReset}>
                                    Zurücksetzen
                                </Button>
                            </Col>
                        </Row>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
};

export default PauseCommandModal;
